package data

import kotlin.math.round

// CSV 한 줄(출처 단위)
data class FoodSafetyEntry(
    val source: String,       // rule_source
    val verdict: String,      // "avoid" | "caution" | "conditional" | "safe"
    val reliability: Double,  // source_reliability (가중치)
    val note: String? = null, // 임산부_주의 원문(옵션)
    val url: String? = null   // 추후 source_url 생기면 사용
)

// 음식별 요약(여러 Entry 묶음)
data class FoodSafetySummary(
    val name: String,                 // food_kr
    val entries: List<FoodSafetyEntry>
) {
    private val valid = entries.filter { it.reliability > 0.0 }

    val count: Int get() = valid.size

    val weightedAverage: Double get() {
        val denom = valid.sumOf { it.reliability }
        if (denom <= 0.0) return 0.0
        val num = valid.sumOf { scoreOf(it.verdict) * it.reliability }
        return num / denom
    }

    // 0..3 정수(반올림)
    val scoreRounded: Int get() = round(weightedAverage).toInt()

    private fun scoreOf(v: String): Int = when (v.lowercase()) {
        "avoid" -> 0
        "caution" -> 1
        "conditional" -> 2
        "safe" -> 3
        else -> 0
    }
}
